<template>
  <div v-if="visible" class="modal-backdrop">
    <div class="modal-single">
      <h4 class="modal-single-title">{{ title }}</h4>
      <br>
      <div v-html="text"></div>

      <button @click="close(false)">{{ buttonNoText }}</button>
      <button class="confirm-button" @click="close(true)">{{ buttonYesText }}</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      title: '',
      text: '',
      buttonNoText: 'Nein',
      buttonYesText: 'Ja',
      _resolve: (_) => {
      }
    }
  },
  methods: {
    async open(title, text, buttonNoText = 'Nein', buttonYesText = 'Ja') {
      this.title = title
      this.text = text
      this.buttonNoText = buttonNoText;
      this.buttonYesText = buttonYesText;
      this.visible = true
      return new Promise(resolve => {
        this._resolve = resolve
      })
    },
    close(resolve) {
      this._resolve(resolve);
      this.visible = false
    }
  }
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-single {
  background: white;
  padding: 24px 32px;
  border-radius: 16px;
  border: 1px solid black;
  min-width: 700px;
  max-width: 700px;
  text-align: center;
  z-index: 10000;
}

.modal-single-title {
  margin-top: 0;
  color: #007acc;
}

button {
  margin: 16px;
  padding: 8px 20px;
}


button.confirm-button {
  margin: 16px;
  padding: 8px 20px;
  color: whitesmoke;
  background: #007acc;
  border: lightgrey;
}
</style>